import React from 'react';
import PropTypes from 'prop-types';
import SectionFooter from './SectionFooter';
import LessonFooter from './LessonFooter';
import useNextUrl from '../../../hooks/useNextUrl';
import useFeatureFlags, { FEATURE_FLAGS } from '../../../hooks/useFeatureFlags';

export default function LessonCompletionFooter({
  currentProgress,
  nextProgress,
  isSectionComplete,
  isUnitComplete,
  onCancel,
}) {
  const nextUrl = useNextUrl();
  const { inFlag } = useFeatureFlags();
  const inMilestone2 = inFlag(FEATURE_FLAGS.M2_NEW_HOMEPAGE);
  const backLink = inMilestone2 ? `/learning/enrollments/${currentProgress?.pathProgress?.enrollment_id}` : null;

  return (
    <footer className="subject-congrats__overview">
      {isSectionComplete && <SectionFooter backLink={backLink} />}
      {!isSectionComplete && (
        <LessonFooter
          currentProgress={currentProgress}
          nextProgress={nextProgress}
          nextUrl={nextUrl}
          isUnitComplete={isUnitComplete}
          backLink={backLink}
          onCancel={onCancel}
        />
      )}
    </footer>
  );
}

LessonCompletionFooter.propTypes = {
  currentProgress: PropTypes.object.isRequired,
  nextProgress: PropTypes.object.isRequired,
  isSectionComplete: PropTypes.bool,
  isUnitComplete: PropTypes.bool,
  onCancel: PropTypes.func,
};
